// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.settings-modal_modal-content_TXZjR {
  max-width: 750px;
}

.settings-modal_body_In07M {
  background: var(--ui-modal-background);
  padding: 1.5rem 2.25rem;
  min-height: 150px;
  max-height: calc(100vh - 250px);
  overflow-y: auto;
}

.settings-modal_tab-button-enable_xPO2U,
.settings-modal_tab-button-unable_p8_tj {
  border: none;
  transition: all 0.15s cubic-bezier(0, 0.7, 0.3, 0.99);
  height: 30px;
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: var(--ui-modal-background);
  filter: brightness(0.8);
  -webkit-filter: brightness(0.8);
}

.settings-modal_Modaltab_kbCtC {
  position: relative;
  height: 35px;
}

.settings-modal_tab-button-enable_xPO2U {
  filter: brightness(1);
  -webkit-filter: brightness(1);
}

.settings-modal_Modaltab_kbCtC::after {
  content: '';
  position: absolute;
  width: 50%;
  left: 0;
  bottom: 0;
  height: 2px;
  background-color: var(--looks-secondary);
  transition: all 0.15s cubic-bezier(0, 0.7, 0.3, 0.99);
}

.settings-modal_Modaltab_kbCtC:has(button:nth-child(1).settings-modal_tab-button-enable_xPO2U)::after {
  left: 0;
}

.settings-modal_Modaltab_kbCtC:has(button:nth-child(2).settings-modal_tab-button-enable_xPO2U)::after {
  left: 50%;
}

.settings-modal_Modaltab_kbCtC:has(button:active)::after {
  width: 100% !important;
  left: 0 !important;
}

.settings-modal_tab-button-unable_p8_tj:hover {
  filter: brightness(0.9);
  -webkit-filter: brightness(0.9);
}

.settings-modal_tab-button-enable_xPO2U:hover {
  filter: brightness(1.1);
  -webkit-filter: brightness(1.1);
}

.settings-modal_tab-button-enable_xPO2U:active,
.settings-modal_tab-button-unable_p8_tj:active {
  filter: brightness(0.9);
  background: var(--ui-modal-background);
}

/* For small screens, such as in the embed */

@media (max-height: 600px) {
  .settings-modal_modal-content_TXZjR {
    margin: 50px auto;
  }
  .settings-modal_body_In07M {
    max-height: calc(100vh - 150px);
  }
}

.settings-modal_setting_NH7nd {
  display: flex;
  flex-direction: column;
  padding: 0.5rem 1rem;
  margin: 0.25rem 0;
  border-radius: 4px;
}

.settings-modal_setting_NH7nd.settings-modal_active__g3gR {
  background: var(--badge-background);
}

.settings-modal_setting_NH7nd:hover,
.settings-modal_setting_NH7nd:focus-within {
  background: var(--badge-border);
}

.settings-modal_label_xt3GV {
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.settings-modal_setting_NH7nd table {
  border-collapse: collapse;
}

.settings-modal_setting_NH7nd tr,
.settings-modal_setting_NH7nd td,
.settings-modal_setting_NH7nd th {
  padding: 0;
  margin: 0;
  border: 1px solid var(--ui-tertiary);
}

.settings-modal_checkbox_b886x {
  margin-right: 0.5rem;
}

.settings-modal_help-icon_st5nM {
  position: relative;
  border: 0;
  background-color: transparent;
  width: 20px;
  height: 20px;
  background-size: 100%;
  margin-left: 0.5rem;
  cursor: pointer;
}

.settings-modal_help-icon_st5nM img {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  filter: var(--filter-icon-black);
}

.settings-modal_custom-stage-size_EakvX > * {
  margin-right: 0.5rem;
}

.settings-modal_custom-stage-size-input_bPWaB {
  width: 80px;
}

.settings-modal_info_K5LRo {
  margin-bottom: 0.25rem;
}

.settings-modal_header_GB6qm {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0.5rem 0 0 0;
  font-weight: bold;
}

.settings-modal_divider_Xifj4 {
  flex-grow: 1;
  margin-left: 1rem;
  border-top: 1px dashed var(--ui-tertiary);
}

.settings-modal_button_iwiuL {
  font-family: inherit;
  font-size: 14px;
  background-color: var(--looks-secondary);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  margin: 0;
  border-radius: 4px;
  cursor: pointer;
  font-family: inherit;
  font-weight: bold;
}

.settings-modal_button_iwiuL:active,
.settings-modal_button_iwiuL:focus-within {
  box-shadow: 0 0 0 3px var(--looks-transparent);
}

.settings-modal_warning_v4b0C {
  padding: 0.5rem 1rem;
  margin: 0.25rem 0;
  border-radius: 4px;
  background: rgb(233, 233, 53);
  color: var(--text-primary-default);
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-settings-modal/settings-modal.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,qDAAqD;EACrD,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,sCAAsC;EACtC,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,SAAS;EACT,WAAW;EACX,wCAAwC;EACxC,qDAAqD;AACvD;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;EAEE,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA,4CAA4C;;AAE5C;EACE;IACE,iBAAiB;EACnB;EACA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,UAAU;EACV,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,wCAAwC;EACxC,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;AACpC","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.modal-content {\n  max-width: 750px;\n}\n\n.body {\n  background: var(--ui-modal-background);\n  padding: 1.5rem 2.25rem;\n  min-height: 150px;\n  max-height: calc(100vh - 250px);\n  overflow-y: auto;\n}\n\n.tab-button-enable,\n.tab-button-unable {\n  border: none;\n  transition: all 0.15s cubic-bezier(0, 0.7, 0.3, 0.99);\n  height: 30px;\n  line-height: 1.5;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  background: var(--ui-modal-background);\n  filter: brightness(0.8);\n  -webkit-filter: brightness(0.8);\n}\n\n.Modaltab {\n  position: relative;\n  height: 35px;\n}\n\n.tab-button-enable {\n  filter: brightness(1);\n  -webkit-filter: brightness(1);\n}\n\n.Modaltab::after {\n  content: '';\n  position: absolute;\n  width: 50%;\n  left: 0;\n  bottom: 0;\n  height: 2px;\n  background-color: var(--looks-secondary);\n  transition: all 0.15s cubic-bezier(0, 0.7, 0.3, 0.99);\n}\n\n.Modaltab:has(button:nth-child(1).tab-button-enable)::after {\n  left: 0;\n}\n\n.Modaltab:has(button:nth-child(2).tab-button-enable)::after {\n  left: 50%;\n}\n\n.Modaltab:has(button:active)::after {\n  width: 100% !important;\n  left: 0 !important;\n}\n\n.tab-button-unable:hover {\n  filter: brightness(0.9);\n  -webkit-filter: brightness(0.9);\n}\n\n.tab-button-enable:hover {\n  filter: brightness(1.1);\n  -webkit-filter: brightness(1.1);\n}\n\n.tab-button-enable:active,\n.tab-button-unable:active {\n  filter: brightness(0.9);\n  background: var(--ui-modal-background);\n}\n\n/* For small screens, such as in the embed */\n\n@media (max-height: 600px) {\n  .modal-content {\n    margin: 50px auto;\n  }\n  .body {\n    max-height: calc(100vh - 150px);\n  }\n}\n\n.setting {\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem 1rem;\n  margin: 0.25rem 0;\n  border-radius: 4px;\n}\n\n.setting.active {\n  background: var(--badge-background);\n}\n\n.setting:hover,\n.setting:focus-within {\n  background: var(--badge-border);\n}\n\n.label {\n  height: 32px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.setting table {\n  border-collapse: collapse;\n}\n\n.setting tr,\n.setting td,\n.setting th {\n  padding: 0;\n  margin: 0;\n  border: 1px solid var(--ui-tertiary);\n}\n\n.checkbox {\n  margin-right: 0.5rem;\n}\n\n.help-icon {\n  position: relative;\n  border: 0;\n  background-color: transparent;\n  width: 20px;\n  height: 20px;\n  background-size: 100%;\n  margin-left: 0.5rem;\n  cursor: pointer;\n}\n\n.help-icon img {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  filter: var(--filter-icon-black);\n}\n\n.custom-stage-size > * {\n  margin-right: 0.5rem;\n}\n\n.custom-stage-size-input {\n  width: 80px;\n}\n\n.info {\n  margin-bottom: 0.25rem;\n}\n\n.header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin: 0.5rem 0 0 0;\n  font-weight: bold;\n}\n\n.divider {\n  flex-grow: 1;\n  margin-left: 1rem;\n  border-top: 1px dashed var(--ui-tertiary);\n}\n\n.button {\n  font-family: inherit;\n  font-size: 14px;\n  background-color: var(--looks-secondary);\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  margin: 0;\n  border-radius: 4px;\n  cursor: pointer;\n  font-family: inherit;\n  font-weight: bold;\n}\n\n.button:active,\n.button:focus-within {\n  box-shadow: 0 0 0 3px var(--looks-transparent);\n}\n\n.warning {\n  padding: 0.5rem 1rem;\n  margin: 0.25rem 0;\n  border-radius: 4px;\n  background: rgb(233, 233, 53);\n  color: var(--text-primary-default);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-content": `settings-modal_modal-content_TXZjR`,
	"modalContent": `settings-modal_modal-content_TXZjR`,
	"body": `settings-modal_body_In07M`,
	"tab-button-enable": `settings-modal_tab-button-enable_xPO2U`,
	"tabButtonEnable": `settings-modal_tab-button-enable_xPO2U`,
	"tab-button-unable": `settings-modal_tab-button-unable_p8_tj`,
	"tabButtonUnable": `settings-modal_tab-button-unable_p8_tj`,
	"Modaltab": `settings-modal_Modaltab_kbCtC`,
	"modaltab": `settings-modal_Modaltab_kbCtC`,
	"setting": `settings-modal_setting_NH7nd`,
	"active": `settings-modal_active__g3gR`,
	"label": `settings-modal_label_xt3GV`,
	"checkbox": `settings-modal_checkbox_b886x`,
	"help-icon": `settings-modal_help-icon_st5nM`,
	"helpIcon": `settings-modal_help-icon_st5nM`,
	"custom-stage-size": `settings-modal_custom-stage-size_EakvX`,
	"customStageSize": `settings-modal_custom-stage-size_EakvX`,
	"custom-stage-size-input": `settings-modal_custom-stage-size-input_bPWaB`,
	"customStageSizeInput": `settings-modal_custom-stage-size-input_bPWaB`,
	"info": `settings-modal_info_K5LRo`,
	"header": `settings-modal_header_GB6qm`,
	"divider": `settings-modal_divider_Xifj4`,
	"button": `settings-modal_button_iwiuL`,
	"warning": `settings-modal_warning_v4b0C`
};
export default ___CSS_LOADER_EXPORT___;
